import { lazy } from "react";

export {
  DOCUMENT_REGISTER_LIST_PATH,
  DOCUMENT_REGISTER_TAB_PARAM,
  DOCUMENT_REGISTER_ALL_TAB,
  DOCUMENT_REGISTER_MY_TEAM_TAB,
} from "./path";
export const DocumentRegisterListPage = lazy(() => import("./page"));
